import { IconProps } from 'interfaces';
import COLOR from 'constants/color';

const QuestionMark = ({
  fill = COLOR.GRAY['900'],
  className = 'w-4 h-4',
  styles
}: IconProps) => {
  return (
    <svg
      className={styles || className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'
    >
      <path
        d='M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17h.01'
        stroke={fill}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='12' cy='12' r='10' stroke={fill} strokeWidth='2' />
    </svg>
  );
};

export default QuestionMark;
